import React from 'react'
import INFTInput from './INFTInput'
import { InputDescription, InputError, InputField, InputWrapper, InputLabel } from './styled'

export default function NFTInput(props: INFTInput) {
  const {
    errorMessage,
    id,
    htmlFor,
    placeholder,
    name,
    label,
    description,
    onKeyUp,
    optional,
    value,
    validate,
    isValid
  } = props
  return (
    <InputWrapper style={props.style}>
      {label && <InputLabel htmlFor={htmlFor ? htmlFor : id}>
        {label} {optional && <span>(Optional)</span>}
      </InputLabel>}
      <InputField
        className={errorMessage || isValid === false ? 'error' : ''}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        validate={validate}
        onKeyUp={(e: any) => {
          if (onKeyUp) {
            onKeyUp(e.currentTarget.value)
          }
        }}
      />
      {description && <InputDescription>{description}</InputDescription>}
      {errorMessage && <InputError>{errorMessage}</InputError>}
    </InputWrapper>
  )
}
